import { create } from 'zustand';

import { SMALL_DEVICE_QUERY } from "~/const";
import { IPageData, IPDPhoto, IPGPhotosData } from "~/interfaces";
import { getDefaultLang } from "~/providers/lang";


interface IMainStore {
	data: {
		lang: string;
		pageData: IPageData;
		trans: Record<string, never>;
		allUsedPhotos: Array<string>,
		photosData: IPGPhotosData;
		isSmallDevice: boolean;
	};
	setLang: (lang: string) => void;
	setPageData: (pageData: IPageData) => void;
	setSmallDevice: (smallDevice: boolean) => void;
}

const photosDataDef: IPGPhotosData = {
	action: {
		name: "action",
		title: "Akce",
		photos: [],
		loaded: 0,
		count: 0,
	},
	addons: {
		name: "addons",
		title: "Doplňky",
		photos: [],
		loaded: 0,
		count: 0,
	},
	formal: {
		name: "formal",
		title: "Společenské šaty",
		photos: [],
		loaded: 0,
		count: 0,
	},
	schoolWedding: {
		name: "schoolWedding",
		title: "Polonéza",
		photos: [],
		loaded: 0,
		count: 0,
	},
	shop: {
		name: "shop",
		title: "Obchod",
		photos: [],
		loaded: 0,
		count: 0,
	},
	wedding: {
		name: "wedding",
		title: "Obchod",
		photos: [],
		loaded: 0,
		count: 0,
	},
};
const pageDataDef = {
	version: "",
	photos: {
		formal: [],
		wedding: [],
		schoolWedding: [],
		action: [],
		addons: [],
		shop: [],
	},
	lang: {},
};

function getPhotos(source: any, allUsedPhotos: Array<string>) {
	const usedPhotos: {[key: string]: number} = {};
	const photosOutput: Array<IPDPhoto> = [];

	for (let ind = 0, max = source.length; ind < max; ind++) {
		let curPhoto = 0;

		for (let photoInd = 0, photoMax = source[ind].length; photoInd < photoMax; photoInd++) {
			const photo = source[ind][photoInd];

			curPhoto++;

			if (photo.photo in usedPhotos) {
				continue;
			}

			usedPhotos[photo.photo] = 1;
			photosOutput.push({
				...photo,
				page: ind + 1,
				order: curPhoto,
			});

			const name = photo.photo.replace(/.*\//u, "");

			allUsedPhotos.push(name.replace("-#s-", "-"));
		}
	}

	return photosOutput;
}

export const mainStore = create<IMainStore>(set => ({
	data: {
		lang: getDefaultLang(),
		pageData: pageDataDef,
		trans: {},
		allUsedPhotos: [],
		photosData: photosDataDef,
		isSmallDevice: window.matchMedia(SMALL_DEVICE_QUERY).matches,
	},
	setLang: lang => set(state => ({
		data: {
			...state.data,
			lang,
		},
	})),
	// @ts-expect-error typ
	setPageData: pageData => set(state => {
		const curPhotosData = state.data.photosData;
		const curAllPhotos = state.data.allUsedPhotos;

		// nastavime vsechna data - todor - smazeme stare fotky
		curPhotosData.action.photos = getPhotos(pageData.photos.action, curAllPhotos);
		curPhotosData.addons.photos = getPhotos(pageData.photos.addons, curAllPhotos);
		curPhotosData.formal.photos = getPhotos(pageData.photos.formal, curAllPhotos);
		curPhotosData.schoolWedding.photos = getPhotos(pageData.photos.schoolWedding, curAllPhotos);
		curPhotosData.shop.photos = getPhotos(pageData.photos.shop, curAllPhotos);
		curPhotosData.wedding.photos = getPhotos(pageData.photos.wedding, curAllPhotos);

		curAllPhotos.sort((aItem, bItem) => aItem.localeCompare(bItem));

		return {
			data: {
				...state.data,
				trans: pageData.lang,
				pageData,
				photosData: curPhotosData,
				allUsedPhotos: curAllPhotos,
			},
		};
	}),
	setSmallDevice: isSmallDevice => set(state => ({
		data: {
			...state.data,
			isSmallDevice,
		},
	})),
}));
